module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('main-menu', {
    key: _vm.$route.fullPath
  }), _vm._v(" "), _c('b-container', [_c('transition', {
    attrs: {
      "name": _vm.transitionName(),
      "mode": "out-in"
    }
  }, [_c('div', {
    key: _vm.$route.fullPath
  }, [_c('b-row', [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('footer', [_c('p', [_vm._v("© Videdressing 2017 - " + _vm._s(_vm.currentYear))]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://github.com/videdressing/the_11"
    }
  }, [_vm._v("Docs")])])])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b405dc7c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 666
// module chunks = 1